import React from 'react';
import { classList } from '../../../../../utils/string.ts';
import { Ad } from './ad.tsx';

const displacedStickyAdWidth = 300;

export type DisplacedStickyAdsProps = {
  leftAd: boolean;
  rightAd: boolean;
};

export const DisplacedStickyAds: React.FunctionComponent<
  React.PropsWithChildren<DisplacedStickyAdsProps>
> = props => {
  return (
    <div className="flex justify-center">
      {props.leftAd && <DisplacedStickyAd adId="sk_sidebar_left" placement="left" />}
      <div className="min-w-0 grow-0">{props.children}</div>
      {props.rightAd && <DisplacedStickyAd adId="sk_sidebar" placement="right" />}
    </div>
  );
};

type DisplacedStickyAdProps = {
  adId: string;
  placement: 'left' | 'right';
  className?: string;
};

/**
 * This is used to have an ad aligned with the main content,
 * but actually be visible outside the main content.
 */
const DisplacedStickyAd: React.FunctionComponent<DisplacedStickyAdProps> = props => {
  const { placement } = props;
  return (
    <div
      className={classList(
        'hidden md:block',
        placement === 'left' && 'mr-4 text-right',
        placement === 'right' && 'ml-4',
        props.className
      )}
      style={(() => {
        switch (placement) {
          case 'left':
            return { width: displacedStickyAdWidth, marginLeft: -1 * displacedStickyAdWidth };
          case 'right':
            return { width: displacedStickyAdWidth, marginRight: -1 * displacedStickyAdWidth };
        }
      })()}
    >
      <div className="sticky top-4">
        <Ad adId={props.adId} />
      </div>
    </div>
  );
};
